<script>
    import { navigate } from "svelte-routing";

    import DocListItem from "../components/DocListItem.svelte";

    import FirestoreCollection from "../components/firestore/FirestoreCollection.svelte";
    import { CATEGORY_DOC } from "../models";

    const handleClick = (uid) => {
        navigate(`/categories/${uid}`);
    };
</script>

<main class="p-4">
    <FirestoreCollection path="categories" let:collection>
        {#each collection as doc}
            <div class="cursor-pointer">
                <DocListItem
                    {doc}
                    form={CATEGORY_DOC}
                    on:click={() => handleClick(doc.uid)} />
            </div>
        {/each}
    </FirestoreCollection>
</main>
